import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState = {
  createOrderData: {},
  createOrderLoading: false,
  createOrderError: null as SerializedError | null,
};

interface ICreateOrderInput {
  activityId: string;
  accessToken: string;
}

export const createOrderFunc = createAsyncThunk(
  'createOrder/createOrderFunc',
  async (values: ICreateOrderInput) => {
    const data1 = JSON.stringify({
      query: `mutation User_createOrderWithIyzicoCheckoutFormPayment($orderInput: CreateOrderWithCheckoutFormInput!, $paymentInput: InitiateCheckoutFormInput) {
      user_createOrderWithIyzicoCheckoutFormPayment(orderInput: $orderInput, paymentInput: $paymentInput) {
        order {
          _id
        }
        paymentResult {
          checkoutFormContent
          paymentPageUrl
          errorCode
          errorMessage
          errorGroup
        }
      }
    }`,
      variables: {
        orderInput: {
          activityId: values.activityId,
        },
        paymentInput: {
          paymentChannel: 'WEB',
        },
      },
    });

    const config = initialConfig(
      'https://api.hophop.com.tr/payment/graphql',
      data1,
      values.accessToken
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const createOrder = createSlice({
  name: 'createOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createOrderFunc.pending, (state) => {
      state.createOrderLoading = true;
    });
    builder.addCase(createOrderFunc.fulfilled, (state, action) => {
      state.createOrderLoading = false;
      state.createOrderData = action.payload?.data?.user_createOrderWithIyzicoCheckoutFormPayment;
      state.createOrderError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(createOrderFunc.rejected, (state, action) => {
      state.createOrderLoading = false;
      state.createOrderError = action.error;
    });
  },
});

export default createOrder.reducer;
